module.exports = __webpack_public_path__ + "img/multi-pid.228b6e2a.png";